import controleAdesoes from '@/core/store/relatorios/controle-adesoes/index'
import controleSaldos from '@/core/store/relatorios/controle-saldos/index'
import painel from '@/core/store/relatorios/painel/index'

export default {
	modules: {
		controleAdesoes,
		controleSaldos,
		painel,
	},
}
